/**
 * @generated SignedSource<<e9b893f59ee958c77b6bedee8f0d6a5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type CreateAdminUserInput = {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone: string;
  clientMutationId?: string | null;
};
export type createPageCreateAdminUserMutation$variables = {
  input: CreateAdminUserInput;
};
export type createPageCreateAdminUserMutationVariables = createPageCreateAdminUserMutation$variables;
export type createPageCreateAdminUserMutation$data = {
  readonly createAdminUser: {
    readonly adminUser: {
      readonly id: string;
      readonly createdAt: any;
      readonly phone: string;
      readonly email: string;
      readonly firstName: string;
      readonly lastName: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type createPageCreateAdminUserMutationResponse = createPageCreateAdminUserMutation$data;
export type createPageCreateAdminUserMutation = {
  variables: createPageCreateAdminUserMutationVariables;
  response: createPageCreateAdminUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAdminUserPayload",
    "kind": "LinkedField",
    "name": "createAdminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "adminUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageCreateAdminUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageCreateAdminUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4ca1e0b9146c14e92c2d3847be3f78cd",
    "id": null,
    "metadata": {},
    "name": "createPageCreateAdminUserMutation",
    "operationKind": "mutation",
    "text": "mutation createPageCreateAdminUserMutation(\n  $input: CreateAdminUserInput!\n) {\n  createAdminUser(input: $input) {\n    adminUser {\n      id\n      createdAt\n      phone\n      email\n      firstName\n      lastName\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13607910ff7d657bcee90b227caeb2c4";

export default node;
